module.exports = __webpack_public_path__ + "img/lynda.9491cf3f.svg";